import { render, staticRenderFns } from "./terms-en-US.vue?vue&type=template&id=50948df8"
import script from "./terms-en-US.vue?vue&type=script&lang=ts"
export * from "./terms-en-US.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports